export const pagingControlsTypes = {
    firstPage: 'fp',
    previousPage: 'pp',
    twoPagesBefore: 'tpb',
    currentPage: 'cp',
    nextPage: 'np',
    twoPagesNext: 'tpn',
    lastPage: 'lp'
};

export default {
    pagingControlsTypes
};
